import React, { Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoForm from '../../components/site/Forms/DemoForm'

import './CardsEstrategias.scss'

export default function (props) {
    return (
        <Fragment>
            <section className="cards-estrategias">
                <div className="container section-title">
                    <h5 className="overtitle">+14 milhões de PEDIDOS EMITIDOS POR ANO</h5>
                    <h2 className='title'>
                        O Mercos é o sistema de vendas mais utilizado do mercado
                    </h2>
                </div>
                <div className="wrapper">
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/erps-integrados.png"
                            alt='+ de 200 ERPs Integrados'
                        />
                        <h4 className="card-title">+ de 200 ERPs Integrados</h4>
                        <h5 className='card-description'>Integre o Mercos com o ERP que você já usa e organize sua operação comercial.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/mais-pratico.png"
                            alt='+ Prático do mercado'
                        />
                        <h4 className="card-title">+ Prático do mercado</h4>
                        <h5 className='card-description'>Intuitivo e fácil de usar, pensado na experiência do gestor, vendedor e cliente.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/suporte-completo.png"
                            alt='Suporte completo'
                        />
                        <h4 className="card-title">Suporte completo</h4>
                        <h5 className='card-description'>Nosso time ajuda você, toda a sua equipe e seus representantes a usarem o Mercos.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/operacao-comercial.png"
                            alt='Controle de toda sua operação comercial'
                        />
                        <h4 className="card-title">Controle de toda sua  <br/>operação comercial</h4>
                        <h5 className='card-description'>Sincronize seus pedidos e mantenha seu estoque sempre atualizado e organizado.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/pedidos-offline.png"
                            alt='Pedidos offline e agilidade para os vendedores'
                        />
                        <h4 className="card-title">Pedidos offline e agilidade <br/>para os vendedores</h4>
                        <h5 className='card-description'>Emita pedidos de onde estiver, mesmo sem conexão com internet, por Android ou iOS.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/new-home/relatorios-personalizaveis.png"
                            alt='+ de 25 relatórios e indicadores personalizáveis'
                        />
                        <h4 className="card-title">+ de 25 relatórios e indicadores <br/>personalizáveis</h4>
                        <h5 className='card-description'>Acompanhe o desempenho da sua equipe, além de metas e comissões em tempo real.</h5>
                    </div>
                </div>

            </section>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardsEstrategias/CardsEstrategiasHome.jsx